<template>
    <main class="page-wrapper rbt-dashboard-page">
        <div class="rbt-panel-wrapper">
            <Header :acao="navegar"></Header>
            

            <!-- Imroz Preloader -->
            <!--<div class="preloader">
                <div class="loader">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
            </div>-->

            <!-- Start Left panel -->
            <Navegacao :acao="navegar" :nmComponente="componente" :reload="reloadNavegacao"></Navegacao>

        </div>
        <!-- End Left panel -->
        <!-- Main content -->
        <template v-if="componente">
            <component v-if="componente" :is="componente" :reload="reload" :reloadNavegacao="recarregarNavegacao"></component>
        </template>
    </main>
</template>
<script>
    import Navegacao from '@/components/Navegacao'
    import Chat from '@/components/Chat'
    import Artefato from '@/components/Artefato'
    import Research from '@/components/Research'
    import GerenciarUsuarios from '@/components/GerenciarUsuarios'
    import RelatorioUso from '@/components/RelatorioUso'

    import Header from '@/components/Header'
    import { navegacaoKey } from '@/config/global'

    export default {
        name: 'Home',
        components: { Navegacao, Chat, Artefato, Research, GerenciarUsuarios, RelatorioUso, Header },
        data: function () {
            return {
                componente: "Chat",
                reload: false,

                reloadNavegacao: false,
            }
        },

        methods: {
            load() {
                if (localStorage.getItem(navegacaoKey) != null) {
                    this.navegar(localStorage.getItem(navegacaoKey));
                }
            },

            navegar(nmComponente) {
                this.componente = nmComponente;
                this.reload = !this.reload;
                localStorage.setItem(navegacaoKey, nmComponente);
            },

            recarregarNavegacao() {
                this.reloadNavegacao = !this.reloadNavegacao;
            }
        },
        mounted: function () {
            this.load();
            let lib = document.createElement('script')
            lib.setAttribute('src', "/assets/js/main.js")
            document.body.appendChild(lib)
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>

</style>

